define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/LookupDataSources", "../../utils/kendoUtils", "../../models/UserContext", "../../models/ProductModel", "../../models/BulkEditProductModel"], function (require, exports, $, ko, log, tools, LookupDataSources, KendoUtils, UserContext, ProductModel, BulkEditProductModel) {
    "use strict";
    var ProductActions = /** @class */ (function () {
        function ProductActions() {
            this.userCanEditProduct = ko.observable(UserContext.hasAccess("Admin,Product.Edit,Product.Delete"));
            this.userCanDeleteProduct = ko.observable(UserContext.hasAccess("Admin,Product.Delete"));
            this.editModel = ko.observable(new ProductModel());
            this.bulkEditProductModel = ko.observable(new BulkEditProductModel());
            this.commissionRoleRates = [];
            this.bulkIsFlat = ko.observable(false);
            this.bulkRate = ko.observable(0);
            this.bulkRateFormat = ko.observable("p2");
        }
        ProductActions.prototype.editProduct = function (id) {
            var self = this;
            var title = "Add New Product";
            if (!isNaN(id)) {
                title = "Edit Product";
            }
            self.bulkIsFlat.subscribe(function () {
                if (self.bulkIsFlat()) {
                    self.bulkRateFormat("c2");
                }
                else {
                    self.bulkRateFormat("p2");
                }
            });
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalClass: "full-width",
                modalOptions: {},
                save: function (event, modal) {
                    self.editModel().ProductType(self.productTypesDropDown.value());
                    self.editModel().CategoryId(self.parentCategoryDropDown.value());
                    self.editModel().SupplierId(self.suppliersDropDown.value());
                    self.editModel().Tax1Id(self.tax1DropDown.value());
                    self.editModel().Tax2Id(self.tax2DropDown.value());
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Product name is required");
                        return;
                    }
                    if (self.editModel().Tax1Id() && self.editModel().Tax1Id() === self.editModel().Tax2Id()) {
                        tools.error("Taxes can not be the same");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveProduct(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    var lookupData = null;
                    if (!self.commissionRoleLookupList || !self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure) {
                        lookupData = self.getLookupData();
                    }
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/Products/GetProductById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new ProductModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new ProductModel());
                    }
                    $.when(getModelCall, lookupData).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'product-edit-template', data: $root }\"></div>");
                        ko.applyBindings(self, modal);
                        var parentContainer = $(".modal-body", modal);
                        var lookupDataSources = new LookupDataSources();
                        var categoriesDataSource = lookupDataSources.createLookupDataSource("ProductCategories", {
                            serverPaging: false,
                            serverFiltering: false
                        });
                        var suppliersDataSource = lookupDataSources.createLookupDataSource("Suppliers", {
                            serverPaging: false,
                            serverFiltering: false
                        });
                        var taxesDataSource = lookupDataSources.createLookupDataSource("TaxesById", {
                            serverPaging: true,
                            serverFiltering: true
                        });
                        var productTypesDataSource = lookupDataSources.createLookupDataSource("ProductItemTypes", {
                            serverPaging: false,
                            serverFiltering: false
                        });
                        self.productTypesDropDown = $("input[name=ProductType]", modal).kendoDropDownList({
                            dataSource: productTypesDataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            popup: {
                                appendTo: parentContainer
                            }
                        }).data("kendoDropDownList");
                        self.parentCategoryDropDown = $("input[name=CategoryId]", modal).kendoDropDownList({
                            dataSource: categoriesDataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Select Category",
                            filter: "contains",
                            popup: {
                                appendTo: parentContainer
                            }
                        }).data("kendoDropDownList");
                        self.suppliersDropDown = $("input[name=SupplierId]", modal).kendoDropDownList({
                            dataSource: suppliersDataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            filter: "contains",
                            popup: {
                                appendTo: parentContainer
                            }
                        }).data("kendoDropDownList");
                        self.tax1DropDown = $("input[name=Tax1Id]", modal).kendoDropDownList({
                            dataSource: taxesDataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Select Tax",
                            filter: "contains",
                            popup: {
                                appendTo: parentContainer
                            }
                        }).data("kendoDropDownList");
                        self.tax2DropDown = $("input[name=Tax2Id]", modal).kendoDropDownList({
                            dataSource: taxesDataSource,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Select Tax",
                            filter: "contains",
                            popup: {
                                appendTo: parentContainer
                            }
                        }).data("kendoDropDownList");
                        self.productTypesDropDown.value(self.editModel().ProductType());
                        self.parentCategoryDropDown.value(self.editModel().CategoryId());
                        self.suppliersDropDown.value(self.editModel().SupplierId());
                        self.tax1DropDown.value(self.editModel().Tax1Id());
                        self.tax2DropDown.value(self.editModel().Tax2Id());
                        self.initRatesGrid(self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure, id, parentContainer);
                    });
                }
            });
        };
        ProductActions.prototype.bulkEditProducts = function (products) {
            var self = this;
            self.bulkEditProductModel(new BulkEditProductModel());
            var productIds = ko.utils.arrayMap(products, function (item) {
                return item.id;
            });
            self.bulkEditProductModel().Products(products);
            self.bulkEditProductModel().ProductIds(productIds);
            tools.editModal({
                title: "Products Bulk Edit",
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.saveBulkEditCustomers(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'bulk-product-edit-template', data: bulkEditProductModel }\"></div>");
                    ko.applyBindings(self, modal);
                    var parentContainer = $(".modal-body", modal);
                    var lookupDataSources = new LookupDataSources();
                    var categoriesDataSource = lookupDataSources.createLookupDataSource("ProductCategories", {
                        serverPaging: false,
                        serverFiltering: false
                    });
                    var taxesDataSource = lookupDataSources.createLookupDataSource("TaxesById", {
                        serverPaging: true,
                        serverFiltering: true
                    });
                    var productTypesDataSource = lookupDataSources.createLookupDataSource("ProductItemTypes", {
                        serverPaging: false,
                        serverFiltering: false
                    });
                    self.productTypesDropDown = $("input[name=ProductType]", modal).kendoDropDownList({
                        dataSource: productTypesDataSource,
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        popup: {
                            appendTo: parentContainer
                        }
                    }).data("kendoDropDownList");
                    self.parentCategoryDropDown = $("input[name=CategoryId]", modal).kendoDropDownList({
                        dataSource: categoriesDataSource,
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        optionLabel: "Select Category",
                        filter: "contains",
                        popup: {
                            appendTo: parentContainer
                        }
                    }).data("kendoDropDownList");
                    self.tax1DropDown = $("input[name=Tax1Id]", modal).kendoDropDownList({
                        dataSource: taxesDataSource,
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        optionLabel: "Select Tax",
                        filter: "contains",
                        popup: {
                            appendTo: parentContainer
                        }
                    }).data("kendoDropDownList");
                    self.tax2DropDown = $("input[name=Tax2Id]", modal).kendoDropDownList({
                        dataSource: taxesDataSource,
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        optionLabel: "Select Tax",
                        filter: "contains",
                        popup: {
                            appendTo: parentContainer
                        }
                    }).data("kendoDropDownList");
                    self.bulkEditProductModel().BulkEditCategory.subscribe(function (value) {
                        self.parentCategoryDropDown.enable(value);
                    });
                    self.bulkEditProductModel().BulkEditProductType.subscribe(function (value) {
                        self.productTypesDropDown.enable(value);
                    });
                    self.bulkEditProductModel().BulkEditTax1.subscribe(function (value) {
                        self.tax1DropDown.enable(value);
                    });
                    self.bulkEditProductModel().BulkEditTax2.subscribe(function (value) {
                        self.tax2DropDown.enable(value);
                    });
                }
            });
        };
        ProductActions.prototype.saveBulkEditCustomers = function (btn, modal) {
            var self = this;
            self.bulkEditProductModel().CategoryId(self.parentCategoryDropDown.value());
            self.bulkEditProductModel().ProductType(self.productTypesDropDown.value());
            self.bulkEditProductModel().Tax1Id(self.tax1DropDown.value());
            self.bulkEditProductModel().Tax2Id(self.tax2DropDown.value());
            var obj = ko.mapping.toJS(self.bulkEditProductModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Products/SaveBulkEditProducts",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.actionCallback) {
                        self.actionCallback("save");
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ProductActions.prototype.getLookupData = function () {
            var self = this;
            return tools.ajaxGet({
                url: "/CommissionRole/GetProductLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.commissionRoleLookupList = data.Data.lookupLists;
                        if (self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure) {
                            var actions = {
                                field: "",
                                command: ["edit"],
                                width: "86px"
                            };
                            self.commissionRoleLookupList.GridStructures.CommissionRoleRateStructure.columns.push(actions);
                        }
                    }
                }
            });
        };
        ProductActions.prototype.initRatesGrid = function (gridStructure, productId, parentContainer) {
            var self = this;
            var gridId = "tblCommissionRoleRates";
            var columns = gridStructure.columns;
            //add actions column
            self.commissionRoleRatesTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: function (options) {
                            options.success(self.commissionRoleRates);
                        },
                        update: function (options) {
                            options.success(options.data);
                        }
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false,
                    schema: {
                        model: gridStructure.model,
                        data: "",
                        total: function (result) {
                            result = result.data || result;
                            return result.length || 0;
                        }
                    }
                },
                gridOptions: {
                    //toolbar: kendo.template($("#commission-role-rates-toolbar-template").html()),
                    columns: columns,
                    height: 500,
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    editable: {
                        mode: "inline"
                    },
                    save: function (e) {
                        //self.validateOneRecord(e.model);
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    },
                    remove: function (e) {
                        setTimeout(function () {
                            e.sender.saveChanges();
                        }, 100);
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CommissionRoleProduct",
                    title: "Commission Role Rates",
                    enablePdf: false
                },
                /*autoHeight: {
                    totalOffset: 46 + 41 + 3
                },*/
                controller: self,
                parentContainer: parentContainer
            };
            self.commissionRoleRatesTable.initGrid(gridOptions);
            var dataObj = {
                productId: productId
            };
            tools.ajaxPost({
                url: "/CommissionRole/GetProductCommissionRoleRates",
                data: dataObj,
                success: function (result) {
                    self.commissionRoleRates = result.Data;
                    self.commissionRoleRatesTable.refresh();
                }
            });
        };
        ProductActions.prototype.applyBulkRate = function () {
            var self = this;
            var gridData = self.commissionRoleRatesTable.getGridData();
            var dataSource = gridData.dataSource;
            var filters = dataSource.filter();
            var allData = dataSource.data();
            var query = new kendo.data.Query(allData);
            var data = query.filter(filters).data;
            for (var i = 0; i < data.length; i++) {
                var item = data[i];
                item.set("IsFlat", self.bulkIsFlat());
                item.set("Rate", self.bulkRate());
                gridData.saveChanges();
                //self.commissionRoleRatesTable.refresh();
            }
            log.log(data);
        };
        ProductActions.prototype.saveProduct = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            var rates = $.map(self.commissionRoleRates, function (item) {
                return {
                    Id: item.Id,
                    CommissionRoleId: item.CommissionRoleId,
                    IsFlat: item.IsFlat,
                    Rate: item.Rate
                };
            });
            data["Rates"] = JSON.stringify(rates);
            tools.ajaxPost({
                url: "/Products/SaveProduct",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (self.actionCallback) {
                        self.actionCallback("save");
                    }
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ProductActions.prototype.deleteProduct = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Products/DeleteProductConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Product deleted successfully");
                    if (self.actionCallback) {
                        self.actionCallback("delete");
                    }
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        ProductActions.prototype.deleteProductConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Product",
                text: "Are you sure you want to delete product " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteProduct(id);
            });
        };
        return ProductActions;
    }());
    return ProductActions;
});
//# sourceMappingURL=productActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/products/productActions.js
// module id = 292
// module chunks = 2